<template>
  <article class="card block">
    <div class="card-content">
      <div class="columns">
        <div class="column">
          <slot name="img"/>
        </div>
        <div class="column">
          <header class="title is-spaced block">
            <h3 class="is-size-3">{{ title }}</h3>
            <h6 class="period is-size-6">{{ period }}</h6>
          </header>
          <p
            class="subtitle"
            v-html="subtitle"
          />
          <b-taglist>
            <b-tag
              v-for="(tag, index) in tags"
              :key="index"
              type="is-medium">
              {{ tag }}
            </b-tag>
          </b-taglist>
          <ul class="buttons">
            <li
              v-for="(link, index) in links"
              :key="index"
              class="button"
            >
              <a
                :href="link.url"
                target="_blank"
              >
                <span>{{ link.content }}</span>
                <b-icon
                  :pack="link.pack"
                  :icon="link.icon"
                  size="is-small"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    period: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    demo: {
      type: String,
      default: null,
    },
    code: {
      type: String,
      default: null,
    },
    links: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    addDiv() {
      return this.demo !== null || this.code !== null;
    },
  },
};
</script>


<style scoped lang="scss">
.column {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .period {
    margin-top: 1.5rem;
  }

  .tag {
    border: 2px solid $secondary;
    font-weight: bold;
  }
}

.button {
  color: white;
  background: #00adb5;
  border: none;
  font-size: 1.2rem;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.25s ease;
  & > span {
    font-weight: bold;
  }
  & > a {
    color: inherit;
  }

  &:active,
  &:focus,
  &:hover {
    color: white;
  }

  &:hover {
    background-color: #00c5cf;
    box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }
}
</style>
